import { useContext } from 'react';
import { OnboardingContext } from '../contexts/OnboardingContext';
import type { OnboardingContextType } from '../types/onboarding';

/**
 * Custom hook to access onboarding state and actions.
 */
export const useOnboarding = (): OnboardingContextType => {
  return useContext(OnboardingContext);
};
